import { OptionsOrGroups, GroupBase } from "react-select5";

type Props<Option extends { label: string }, ValueType> = {
  options: OptionsOrGroups<Option, GroupBase<Option>>;
  value: ValueType[] | ValueType | undefined | null;
  valueOptionEqualityFn: (a: ValueType, b: Option) => boolean;
  localeArray?: string[];
};

export const sortSelectedFirst = <Option extends { label: string }, ValueType>({
  options,
  value,
  valueOptionEqualityFn,
  localeArray
}: Props<Option, ValueType>): OptionsOrGroups<Option, GroupBase<Option>> => {
  const sortedGroupedOptions: GroupBase<Option>[] = [];
  const sortedOptions: Option[] = [];

  const sortFunction = (a: Option, b: Option) => {
    if (!value) return 0;
    const aSelected = (Array.isArray(value) ? value : [value]).some((v) =>
      valueOptionEqualityFn(v, a)
    );
    const bSelected = (Array.isArray(value) ? value : [value]).some((v) =>
      valueOptionEqualityFn(v, b)
    );
    return aSelected && !bSelected
      ? -1
      : !aSelected && bSelected
      ? 1
      : a.label.localeCompare(b.label, localeArray ? localeArray : ["sv"]);
  };

  options.forEach((option) => {
    if (option && typeof option === "object" && "options" in option) {
      sortedGroupedOptions.push({
        ...option,
        options: option.options.slice().sort(sortFunction)
      });
    } else {
      sortedOptions.push(option as Option);
    }
  });

  sortedOptions.sort(sortFunction);
  return sortedOptions.length ? sortedOptions : sortedGroupedOptions;
};
